export default {
  getStats: state => state.stats
};
